/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class RoleNotificationService {
  private refreshRolesListeners = new Subject<any>();

  constructor() {}

  getRefreshRolesListener(): Subject<any> {
    return this.refreshRolesListeners;
  }

  refreshRoles(): void {
    this.refreshRolesListeners.next();
  }
}
